import ReactDOM from 'react-dom/client';

import { RouterProvider } from 'react-router-dom';

import { loader } from '@monaco-editor/react';
import { App, ConfigProvider } from 'antd';

import { antdThemeConfig } from '@/shared/config/antd-theme';

import { QueryProvider, ThemeProvider } from '@/app/providers';
import { router } from '@/app/routes';

import 'antd/dist/reset.css';
import '@/shared/styles/index.css';
import './index.css';

loader.config({ paths: { vs: '/vs' } });

self.MonacoEnvironment = {
  getWorker(_: unknown, label: string) {
    if (label === 'json') {
      return new Worker('/vs/assets/json.worker.js', { type: 'module' });
    }
    if (label === 'css' || label === 'scss' || label === 'less') {
      return new Worker('/vs/assets/css.worker.js', { type: 'module' });
    }
    if (label === 'html' || label === 'handlebars' || label === 'razor') {
      return new Worker('/vs/assets/html.worker.js', { type: 'module' });
    }
    if (label === 'typescript' || label === 'javascript') {
      return new Worker('/vs/assets/ts.worker.js', { type: 'module' });
    }
    return new Worker('/vs/assets/editor.worker.js', { type: 'module' });
  },
};

ReactDOM.createRoot(document.getElementById('root')!).render(
  <QueryProvider>
    <ThemeProvider>
      <ConfigProvider theme={antdThemeConfig}>
        <App>
          <RouterProvider router={router} />
        </App>
      </ConfigProvider>
    </ThemeProvider>
  </QueryProvider>
);
